import(/* webpackMode: "eager" */ "/vercel/path0/front_end/app/login/page.tsx");
